import { Box, Button, Stack, Typography } from "@mui/material";
import { FC, FormEvent } from "react";
import { CreateAffiliateProps } from "./confirm-change-affiliate-status.types";
import { useUIStore } from "@/stores";
import { useChangeAffiliateStatus } from "../../queries";
import { AffiliateStatus } from "@/types";

const ConfirmChangeAffiliateStatus: FC<CreateAffiliateProps> = ({
  affiliateId,
  prevStatus,
}) => {
  const { closeModal } = useUIStore();

  const { changeAffiliateStatus, isChangeAffiliateStatusLoading } =
    useChangeAffiliateStatus();

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    changeAffiliateStatus({
      affiliateId,
      status:
        prevStatus === AffiliateStatus.ACTIVE
          ? AffiliateStatus.INACTIVE
          : AffiliateStatus.ACTIVE,
    });
  };

  return (
    <Box component={"form"} onSubmit={onSubmit}>
      <Typography>
        Are you sure you want to change the status for this affiliate?
      </Typography>

      <Stack direction={"row"} spacing={2} mt={2}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={closeModal}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="secondary"
          loading={isChangeAffiliateStatusLoading}
          disabled={isChangeAffiliateStatusLoading}
        >
          Confirm
        </Button>
      </Stack>
    </Box>
  );
};

export { ConfirmChangeAffiliateStatus };
